<div class="full-width py-2 px-3" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">
    <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
      <button (click)="close()" class="button-close-top" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="full-width" fxLayout="row" fxLayoutAlign="space-between start">
    <div class="subtitle-default">{{ data.header }}</div>
    <div *ngIf="loading$ | async" class="pe-3" fxLayout="row" fxLayoutAlign="center center">
      <mat-spinner color="primary" diameter="20"></mat-spinner>
    </div>
  </div>

  <div *ngIf="!selectedPeriod.isEditable" class="full-width" fxLayout="row" fxLayoutAlign="space-between start">
    <app-info-panel [message]="['As there have been transaction within this period some fields may not be editable']"
                    [type]="PanelType.WARN">
    </app-info-panel>
  </div>

  <div class="full-width" fxFlexOffset="20px" fxLayout="column" fxLayoutGap="15px">

    @if (editType == 'values' && selectedPeriod.bookingPricing) {
      <span class="heading-default">Rate types and values</span>

      @if (selectedPeriod.rentalPricingOption == RentalPricingOption.FIXED_COMPLEX) {
        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always" style="width: 40%">
            <mat-label>Fixed Rate Type</mat-label>
            <mat-select [(value)]="selectedPeriod.bookingPricing!.spacePricingRateCategory"
                        [disabled]="!selectedPeriod.isEditable || !editingValues"
                        (selectionChange)="onFixedRateTypeChange($event)"
                        class="custom-select-field-value" placeholder="Select">
              <mat-option [value]="SpacePricingRateCategory.PER_PERIOD" class="custom-select-field-option">Per Period
              </mat-option>
              <mat-option [value]="SpacePricingRateCategory.PER_SQM" class="custom-select-field-option">Per <span
                class="ms-2">m<sup>2</sup></span></mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always" style="width: 40%">
            <mat-label>Fixed Rate Period</mat-label>
            <mat-select [(value)]="selectedPeriod.bookingPricing!.patternType" [disabled]="true"
                        class="custom-select-field-value" placeholder="Select">
              @for (pattern of filteredPatternTypes; track pattern.code) {
                <mat-option [value]="pattern.code" class="custom-select-field-option">{{ pattern.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" style="width: 40%">
            <mat-label>Fixed Rate</mat-label>
            <input [(ngModel)]="selectedPeriod.fixedRentalPricingValue" [disabled]="!selectedPeriod.isEditable || !editingValues" class="align-right" matInput
                   min="0" type="number">
            <div class="ms-3" matPrefix>R</div>
            @if (selectedPeriod.bookingPricing?.spacePricingRateCategory === SpacePricingRateCategory.PER_SQM) {
              <div class="me-2" matSuffix><span>/ </span><span class="ms-2">m<sup>2</sup></span></div>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always" style="width: 40%">
            <mat-label>Percentage Rate Type</mat-label>
            <mat-select [disabled]="!selectedPeriod.isEditable || !editingValues"
                        [value]="RentalPricingOption.TURNOVER_PERCENTAGE"
                        class="custom-select-field-value" placeholder="Select">
              <mat-option [value]="RentalPricingOption.TURNOVER_PERCENTAGE" class="custom-select-field-option">
                Percentage Rental
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always" style="width: 40%">
            <mat-label>Variable Rate Type</mat-label>
            <mat-select [disabled]="true" [value]="SpacePricingRateCategory.PERCENTAGE"
                        class="custom-select-field-value" placeholder="Select">
              <mat-option [value]="SpacePricingRateCategory.PERCENTAGE" class="custom-select-field-option">Percentage
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" style="width: 40%">
            <mat-label>% Rate</mat-label>
            <input [(ngModel)]="selectedPeriod.rentalPricingTurnoverPercentageValue"
                   [disabled]="!selectedPeriod.isEditable || !editingValues"
                   class="align-right"
                   matInput
                   type="number">
            <span class="me-2" matSuffix>%</span>
          </mat-form-field>
        </div>
      } @else {
        <div fxLayout="row" fxLayoutGap="10px">

          <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always" style="width: 40%">
            <mat-label>Fixed Rate Type</mat-label>
            <mat-select [(value)]="selectedPeriod.rentalPricingOption"
                        [disabled]="!selectedPeriod.isEditable || !editingValues"
                        class="custom-select-field-value" placeholder="Select">
              @for (type of fixedRateTypes; track type.code) {
                <mat-option [value]="type.code" class="custom-select-field-option">{{ type.label }}</mat-option>
              }
              @if (selectedPeriod.rentalPricingOption == RentalPricingOption.TURNOVER_PERCENTAGE) {
                <mat-option [disabled]="true" [value]="RentalPricingOption.TURNOVER_PERCENTAGE"
                            class="custom-select-field-option">Percentage Turnover
                </mat-option>
              }
              @if (selectedPeriod.rentalPricingOption == RentalPricingOption.PRICING_MODEL) {
                <mat-option [disabled]="true" [value]="RentalPricingOption.PRICING_MODEL"
                            class="custom-select-field-option">Fixed Rental
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" style="width: 40%">
            <mat-label>Fixed Rate</mat-label>
            <input [(ngModel)]="selectedPeriod.fixedRentalPricingValue" [disabled]="!selectedPeriod.isEditable || !editingValues" class="align-right" matInput
                   min="0" type="number">
            <div class="ms-3" matPrefix>R</div>
            @if (selectedPeriod.rentalPricingOption === RentalPricingOption.FIXED_PER_SQM_PER_MONTH
            || selectedPeriod.rentalPricingOption === RentalPricingOption.PRICING_MODEL
            || selectedPeriod.rentalPricingOption === RentalPricingOption.TURNOVER_PERCENTAGE) {
              <div class="me-2" matSuffix><span>/ </span><span class="ms-2">m<sup>2</sup></span></div>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="outline" class="custom-select-field" floatLabel="always" style="width: 40%">
            <mat-label>Percentage Rate Type</mat-label>
            <mat-select [disabled]="!selectedPeriod.isEditable || !editingValues"
                        [value]="RentalPricingOption.TURNOVER_PERCENTAGE"
                        class="custom-select-field-value" placeholder="Select">
              <mat-option [value]="RentalPricingOption.TURNOVER_PERCENTAGE" class="custom-select-field-option">
                Percentage Rental
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always" style="width: 40%">
            <mat-label>% Rate</mat-label>
            <input [(ngModel)]="selectedPeriod.rentalPricingTurnoverPercentageValue"
                   [disabled]="!selectedPeriod.isEditable || !editingValues"
                   class="align-right"
                   matInput
                   type="number">
            <span class="me-2" matSuffix>%</span>
          </mat-form-field>
        </div>
      }

      <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
        <span class="heading-default">Transaction Fee Charges</span>
        <app-info-panel [message]="['Transaction fees will ' + (selectedPeriod.applyTransactionFee ? '' : 'NOT ')  + 'be charged for all internal and external payment method sales.']"
                        [type]="selectedPeriod.applyTransactionFee ? PanelType.INFO : PanelType.WARN">
        </app-info-panel>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field appearance="outline" class="custom-text-autofill" floatLabel="always">
          <mat-label>Apply Transaction Fees</mat-label>
          <input disabled matInput>
          <span class="body-1-regular-1 ms-3" matPrefix>{{ selectedPeriod.applyTransactionFee ? 'Yes' : 'No' }}</span>
          <div class="me-3" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" matSuffix>
            <mat-slide-toggle (change)="applyTransactionFee($event)"
                              [checked]="selectedPeriod.applyTransactionFee ? selectedPeriod.applyTransactionFee : false"
                              [disabled]="!selectedPeriod.isEditable || !editingValues"
                              color="primary"></mat-slide-toggle>
          </div>
        </mat-form-field>
      </div>

      <div *ngIf="displayPaymentMethodsTable" fxFlexOffset="25px" fxLayout="row">
        <table [dataSource]="paymentMethodsDataSource" class="custom-table" fxFlex="50" mat-table>
          <ng-container matColumnDef="table-label">
            <th *matHeaderCellDef [attr.colspan]="displayedColumns.length" class="custom-table-label"
                mat-header-cell>
              Payment Methods
            </th>
          </ng-container>


          <ng-container matColumnDef="collectionType">
            <th *matHeaderCellDef mat-header-cell> Collection Type</th>
            <td *matCellDef="let element" class="custom-table-cell"
                mat-cell>{{ utils.displayStatus(element.collectionType) }}
              - {{ element.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="transactionFeeType">
            <th *matHeaderCellDef mat-header-cell> Rate Type</th>
            <td *matCellDef="let element" class="custom-table-cell"
                mat-cell> {{ displayFeeType(element.transactionFeeType) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="transactionFee">
            <th *matHeaderCellDef mat-header-cell>Rate</th>
            <td *matCellDef="let element" class="custom-table-cell" mat-cell>
              <div *ngIf="element.transactionFeeType === 'FIXED'" class="body-1-regular-2">
                R {{ element.transactionFee ? element.transactionFee.toFixed(2) : null }}
              </div>
              <div *ngIf="element.transactionFeeType === 'RATE'"
                   class="body-1-regular-2">{{ element.transactionFee }} %
              </div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="['table-label']" class="custom-table-header" mat-header-row></tr>
          <tr *matHeaderRowDef="displayedColumns" class="custom-table-header" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;"
              class="custom-table-row btn-cursor"
              mat-row></tr>
        </table>

      </div>

      <mat-paginator #paymentMethodsPaginator *ngIf="selectedPeriod.applyTransactionFee"
                     [length]="paymentMethodsDataSource ? paymentMethodsDataSource.data.length : 0"
                     [pageSizeOptions]="[5, 10, 25, 100]"
                     [pageSize]="5"
                     class="custom-paginator"></mat-paginator>
    }

    @if (editType == 'dates') {
      <span class="heading-default">Select an earlier end date to reduce how long this pricing period runs. The end date can't be moved later than it currently is, and must leave at least one day after the commencement date. If there are any sales recorded against this period, the end date can't be set earlier than the most recent sale date, as sales must always fall within the active period.</span>
      <div fxFlexAlign="space-between center" fxLayout="row" fxLayoutGap="15px">

        <mat-form-field appearance="outline" class="custom-date-picker" floatLabel="always" style="width: 40%">
          <mat-label>Start Date</mat-label>
          <input (ngModelChange)="onStartDateChange($event)" [(ngModel)]="selectedPeriod.startDate"
                 [disabled]="true"
                 [matDatepicker]="startPicker"
                 [max]="startDateMaxValue"
                 [min]="startDateMinValue"
                 matInput
                 placeholder="select"
          />
          <mat-datepicker-toggle [for]="startPicker" matIconSuffix>
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="custom-date-picker" floatLabel="always" style="width: 40%">
          <mat-label>End Date</mat-label>
          <input (ngModelChange)="onEndDateChange($event)" [(ngModel)]="selectedPeriod.endDate"
                 [disabled]="editingValues"
                 [matDatepicker]="endPicker"
                 [max]="endDateMaxValue"
                 [min]="endDateMinValue"
                 matInput
                 placeholder="select"
          />
          <mat-datepicker-toggle [for]="endPicker" matIconSuffix>
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    }


    <div class="full-width" fxFlexOffset="20px" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
      <button (click)="cancelChanges()" class="button-outline button-primary" mat-flat-button>
        <div class="button-text">Cancel</div>
      </button>
      <button (click)="saveChanges()" class="button-primary" mat-flat-button>
        <div class="button-text">Save</div>
      </button>
    </div>
  </div>

</div>
